import { Loading } from '@eventr/common-storybook'
import { Stack } from '@mui/material'
import { Outlet } from 'react-router-dom'
import { useShallow } from 'zustand/react/shallow'
import ItineraryCarousel from '../../home/components/carousel/ItineraryCarousel'
import { NoOrg } from '../../home/components/noOrg'
import { OrgIsBeeingMade } from '../../home/components/orgIsBeeingMade'
import { useBoundStore } from '../../state/bound.store'
import { useGuestStore } from '../guest/guest.store'

export const HomeRoutes = () => {
    const { profile } = useBoundStore(
        useShallow((s) => {
            return { profile: s.profile }
        })
    )
    const isGuestMode = useGuestStore(useShallow((s) => s.isGuestMode))

    if (!isGuestMode) {
        if (!profile)
            return (
                <Stack direction={'row'} justifyContent={'center'}>
                    <Loading id="Profile-loading" />
                </Stack>
            )

        if (profile.organisations?.length === 0) return <NoOrg />

        if (
            profile.organisations?.length === 1 &&
            profile.organisations?.[0].status === 'creating'
        )
            return <OrgIsBeeingMade />
    }

    return (
        <>
            <ItineraryCarousel />
            <div style={{ height: '100%' }}>
                <Outlet />
            </div>
        </>
    )
}
